export default "//static.tradera.net/touchweb/static/output/images/klarna.72c8202f.svg";